<div class="modal-body content width-500 ">
  <div class="layout-auto-1-auto">
    <span *ngIf="inputWasEmpty" class="modal-header">
      Bildunterschrift erstellen
    </span>
    <span  *ngIf="!inputWasEmpty"  class="modal-header">
      Bildunterschrift ändern
    </span>
    <div class="content layout-auto-1">
      <exg-input  #commentInput
                  [(ngModel)]="comment"
                  [caption]="'Bildunterschrift'"
                  (keyup.enter)="save()"
                  [maxlength]="140">
      </exg-input>
    </div>
    <div class="spawn-modal-actions typo-small">
      <button (click)="save()"
              [class.disabled]="comment.length === 0"
              class="md-btn">
        {{getGlobal('Save')}}
      </button>
      <button (click)="cancel()"
              class="md-btn">
        {{getGlobal('Cancel')}}
      </button>
    </div>
  </div>
</div>
